import { Box, Typography } from '@mui/material';
import { drawerHeader } from '@components/drawerItem/DrawerItem.styles';
import { Button } from '@components/button';
import { ArrowLeft, Thumbtack, ThumbtackSolid, Times } from '@assets/svgs';
import { IconButton } from '@components/iconButton';
import { useSearchParams } from 'react-router-dom';
import { Tooltip } from '@components/tooltip';
import { useStore } from '@store/GlobalStore';
import { shallow } from 'zustand/shallow';

type DrawerHeaderProps = {
  drawerTitle: string;
  drawerParam?: string;
  padding?: string;
  children?: React.ReactNode;
  handleGoBack?: () => void;
  onClose?: (e: any) => void;
};

export const DrawerHeader = (props: DrawerHeaderProps) => {
  const { drawerTitle, padding = '19px 16px 13px', children, handleGoBack, onClose } = props;
  return (
    <Box
      sx={[
        {
          padding,
        },
        ...(Array.isArray(drawerHeader) ? drawerHeader : [drawerHeader]),
      ]}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: handleGoBack ? 'space-between' : 'flex-start',
        }}
      >
        <Typography variant='h6'>{drawerTitle}</Typography>

        {handleGoBack ? (
          <Button variant='text' startIcon={<ArrowLeft height='15' width='15' />} onClick={handleGoBack}>
            Back
          </Button>
        ) : null}
        {onClose ? (
          <Box sx={{ textAlign: 'right', justifyContent: 'flex-end', flex: '1' }}>
            <IconButton onClick={onClose}>
              <Times />
            </IconButton>
          </Box>
        ) : null}
      </Box>
      {children}
    </Box>
  );
};

export const PinDrawer = ({ urlParam, absolute = true }: { urlParam: string; absolute?: boolean }) => {
  const [searchParamsInTheUrl, setSearchParamsInTheUrl] = useSearchParams();
  const [userAuth] = useStore((state) => [state.userAuth], shallow);

  if (!userAuth.isInternalUser) {
    return null;
  }
  const hasPinnedItem = searchParamsInTheUrl.has('sidebarPinned');
  const isSelected = searchParamsInTheUrl.get('sidebarPinned') === urlParam;

  if (hasPinnedItem && !isSelected) {
    return null;
  }
  return (
    <Box sx={absolute ? { position: 'absolute', right: 12, top: 8 } : {}}>
      <Tooltip title={isSelected ? 'Unpin drawer' : 'Pin drawer'} placement='left'>
        <IconButton
          onClick={() => {
            // for now only allow one
            if (isSelected) {
              searchParamsInTheUrl.delete('sidebarPinned');
            } else {
              searchParamsInTheUrl.set('sidebarPinned', urlParam);
            }
            // future: multiple

            //  add 'urlParam' to sidebarPinned if it isnt included, else remove it
            // const pinnedDrawers = searchParamsInTheUrl.get('sidebarPinned')?.split(',') || [];
            // if (pinnedDrawers.includes(urlParam)) {
            //   const newPinnedDrawers = pinnedDrawers.filter((p) => p !== urlParam);
            //   if (newPinnedDrawers.length) {
            //     searchParamsInTheUrl.set('sidebarPinned', newPinnedDrawers.join(','));
            //   } else {
            //     searchParamsInTheUrl.delete('sidebarPinned');
            //   }
            // }

            setSearchParamsInTheUrl(searchParamsInTheUrl, { replace: true });
          }}
        >
          {isSelected ? <ThumbtackSolid width='14px' /> : <Thumbtack width='14px' />}
        </IconButton>
      </Tooltip>
    </Box>
  );
};
